module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "un-auth-wrappers"
  }, [_c('div', {
    class: {
      'closed': _vm.menuClosed
    }
  }, [_c('span', {
    staticClass: "openarrow",
    on: {
      "click": _vm.toggleShareMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-chevron-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "closearrow",
    on: {
      "click": _vm.toggleShareMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-chevron-right"
  })]), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": _vm.metaTag_fb_title,
      "description": _vm.metaTag_fb_title,
      "title": _vm.metaTag_fb_title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "unauth-share-options"
          }, [_c('network', {
            staticClass: "holder",
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), (_vm.heroImage1 && !_vm.showCorporateLiveStreaming()) ? _c('div', {
    staticClass: "slider responsive-slick-slider-top topcarosal"
  }, [_c('div', {
    staticClass: "slide-player"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.heroImage1,
      "alt": "TOP IMAGE 1"
    }
  }), _vm._v(" "), _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_1)
    }
  }), _vm._v(" "), (!_vm.isNativeApp) ? _c('div', {
    staticClass: "buttonholderbanner"
  }, [(_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e(), _vm._v(" "), (!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "home-pink-button",
    on: {
      "click": function($event) {
        return _vm.openTone4GoodLink()
      }
    }
  }, [_vm._v("Find Out More")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.showGiftingLinks) ? _c('i', {
    staticClass: "fa fa-gift"
  }) : _vm._e(), _vm._v(" "), (_vm.showGiftingLinks) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/gifts')
      }
    }
  }, [_c('strong', [_vm._v("GIVE THE GIFT OF TONE")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "slide-player"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.heroImage2,
      "alt": "TOP IMAGE 2"
    }
  }), _vm._v(" "), _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_2)
    }
  }), _vm._v(" "), (!_vm.isNativeApp) ? _c('div', {
    staticClass: "buttonholderbanner"
  }, [(!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "home-pink-button",
    on: {
      "click": function($event) {
        return _vm.openTone4GoodLink()
      }
    }
  }, [_vm._v("Find Out More")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.showGiftingLinks) ? _c('i', {
    staticClass: "fa fa-gift"
  }) : _vm._e(), _vm._v(" "), (_vm.showGiftingLinks) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/gifts')
      }
    }
  }, [_c('strong', [_vm._v("GIVE THE GIFT OF TONE")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "slide-player"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.heroImage3,
      "alt": "TOP IMAGE 3"
    }
  }), _vm._v(" "), _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_3)
    }
  }), _vm._v(" "), (!_vm.isNativeApp) ? _c('div', {
    staticClass: "buttonholderbanner"
  }, [(!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "home-pink-button",
    on: {
      "click": function($event) {
        return _vm.openTone4GoodLink()
      }
    }
  }, [_vm._v("Find Out More")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.showGiftingLinks) ? _c('i', {
    staticClass: "fa fa-gift"
  }) : _vm._e(), _vm._v(" "), (_vm.showGiftingLinks) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/gifts')
      }
    }
  }, [_c('strong', [_vm._v("GIVE THE GIFT OF TONE")])]) : _vm._e()]) : _vm._e()])]) : _c('div', [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8 livestreaming"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.liveEventURL,
      "width": "100%",
      "height": "350px",
      "frameborder": "0",
      "scrolling": "auto",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_12)
    }
  }), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_13)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('section', {
    staticClass: "videoSections"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "tabs hide-mobile"
  }, [_c('ul', [_c('li', {
    staticClass: "videoList",
    on: {
      "click": function($event) {
        return _vm.$router.push('/content/work')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("WORK")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    on: {
      "click": function($event) {
        return _vm.$router.push('/content/life')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("LIFE")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    on: {
      "click": function($event) {
        return _vm.$router.push('/content/mindbody')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("MINDBODY")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    on: {
      "click": function($event) {
        return _vm.$router.push('/content/money')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("MONEY")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_4)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedRoute),
      expression: "selectedRoute"
    }],
    staticClass: "show-mobile routeselect",
    style: ({
      'background-color': _vm.getCorpHeaderColor + ' !important'
    }),
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedRoute = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "name": "workOption",
      "value": "work",
      "selected": ""
    }
  }, [_vm._v("WORK")]), _vm._v(" "), _c('option', {
    attrs: {
      "name": "lifeOption",
      "value": "life"
    }
  }, [_vm._v("LIFE")]), _vm._v(" "), _c('option', {
    attrs: {
      "name": "mindbodyOption",
      "value": "mindbody"
    }
  }, [_vm._v("MINDBODY")]), _vm._v(" "), _c('option', {
    attrs: {
      "name": "moneyOption",
      "value": "money"
    }
  }, [_vm._v("MONEY")])])]), _vm._v(" "), _c('div', {
    staticClass: "slider responsive-slick-slider  hide-mobile"
  }, [_c('div', {
    staticClass: "tabContent",
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {
    staticClass: "row video-row"
  }, _vm._l((_vm.workVideos), function(work) {
    return _c('div', {
      staticClass: "col-xs-6 col-sm-6 col-md-3 slide-player"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + work.mediaid + '/' + work.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": work.image,
        "alt": "WORK SECTION",
        "title": work.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title"
    }, [_vm._v(_vm._s(work.title))])]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(work.mediaid),
        "media": _vm.returnShareURL(work.mediaid),
        "quote": work.title,
        "description": work.Description,
        "title": work.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    attrs: {
      "id": "tabs-2"
    }
  }, [_c('div', {
    staticClass: "row video-row"
  }, _vm._l((_vm.lifeVideos), function(life) {
    return _c('div', {
      staticClass: "col-xs-6 col-sm-6 col-md-3 slide-player"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + life.mediaid + '/' + life.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": life.image,
        "alt": "LIFE SECTION",
        "title": life.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title"
    }, [_vm._v(_vm._s(life.title))])]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(life.mediaid),
        "media": _vm.returnShareURL(life.mediaid),
        "quote": life.title,
        "description": life.Description,
        "title": life.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    attrs: {
      "id": "tabs-3"
    }
  }, [_c('div', {
    staticClass: "row video-row"
  }, _vm._l((_vm.mindbodyVideos), function(mb) {
    return _c('div', {
      staticClass: "col-xs-6 col-sm-6 col-md-3 slide-player"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + mb.mediaid + '/' + mb.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": mb.image,
        "alt": "MINDBODY SECTION",
        "title": mb.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title"
    }, [_vm._v(_vm._s(mb.title))])]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(mb.mediaid),
        "media": _vm.returnShareURL(mb.mediaid),
        "quote": mb.title,
        "description": mb.Description,
        "title": mb.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    attrs: {
      "id": "tabs-4"
    }
  }, [_c('div', {
    staticClass: "row video-row"
  }, _vm._l((_vm.moneyVideos), function(money) {
    return _c('div', {
      staticClass: "col-xs-6 col-sm-6 col-md-3 slide-player"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + money.mediaid + '/' + money.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": money.image,
        "alt": "MONEY SECTION",
        "title": money.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title"
    }, [_vm._v(_vm._s(money.title))])]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(money.mediaid),
        "media": _vm.returnShareURL(money.mediaid),
        "quote": money.title,
        "description": money.Description,
        "title": money.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row mobilevideotabs show-mobile"
  }, [_vm._l((_vm.workVideos), function(work) {
    return (_vm.selectedRoute === 'work') ? _c('div', {
      staticClass: "col-xs-6 smedia"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": work.image,
        "alt": "WORK SECTION",
        "title": work.title
      },
      on: {
        "click": function($event) {
          return _vm.openModal(work)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title",
      on: {
        "click": function($event) {
          return _vm.openModal(work)
        }
      }
    }, [_vm._v(_vm._s(work.title))]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(work.mediaid),
        "media": _vm.returnShareURL(work.mediaid),
        "quote": work.title,
        "description": work.Description,
        "title": work.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.lifeVideos), function(life) {
    return (_vm.selectedRoute === 'life') ? _c('div', {
      staticClass: "col-xs-6"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": life.image,
        "alt": "LIFE SECTION",
        "title": life.title
      },
      on: {
        "click": function($event) {
          return _vm.openModal(life)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title",
      on: {
        "click": function($event) {
          return _vm.openModal(life)
        }
      }
    }, [_vm._v(_vm._s(life.title))]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(life.mediaid),
        "media": _vm.returnShareURL(life.mediaid),
        "quote": life.title,
        "description": life.Description,
        "title": life.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.mindbodyVideos), function(mb) {
    return (_vm.selectedRoute === 'mindbody') ? _c('div', {
      staticClass: "col-xs-6"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": mb.image,
        "alt": "MINDBODY SECTION",
        "title": mb.title
      },
      on: {
        "click": function($event) {
          return _vm.openModal(mb)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title",
      on: {
        "click": function($event) {
          return _vm.openModal(mb)
        }
      }
    }, [_vm._v(_vm._s(mb.title))]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(mb.mediaid),
        "media": _vm.returnShareURL(mb.mediaid),
        "quote": mb.title,
        "description": mb.Description,
        "title": mb.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.moneyVideos), function(money) {
    return (_vm.selectedRoute === 'money') ? _c('div', {
      staticClass: "col-xs-6"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": money.image,
        "alt": "MONEY SECTION",
        "title": money.title
      },
      on: {
        "click": function($event) {
          return _vm.openModal(money)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title",
      on: {
        "click": function($event) {
          return _vm.openModal(money)
        }
      }
    }, [_vm._v(_vm._s(money.title))]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(money.mediaid),
        "media": _vm.returnShareURL(money.mediaid),
        "quote": money.title,
        "description": money.Description,
        "title": money.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()])]), _vm._v(" "), (_vm.getAllExperts) ? _c('section', {
    staticClass: "extertcontainer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.getAllExperts), function(expert) {
    return (expert.unauth_title && expert.small_image_bw) ? _c('div', {
      staticClass: "col-sm-2 col-xs-6"
    }, [_c('a', {
      style: ({
        color: _vm.getCorpHeaderColor + ' !important'
      }),
      attrs: {
        "href": '/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      attrs: {
        "src": expert.small_image_bw,
        "alt": expert.unauth_title,
        "title": expert.unauth_title
      }
    }), _vm._v("\n                            " + _vm._s(expert.unauth_title) + "\n                             ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_5)
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.$router.push('/experts')
      }
    }
  }, [_vm._v("\n                        Meet our Experts\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.getServicePodcast) ? _c('div', [_c('section', {
    staticClass: "radiosection",
    style: ({
      backgroundColor: _vm.podcastBgColor
    })
  }, [_c('h2', {
    staticClass: "text-center",
    style: ({
      color: '#ffffff',
      fontWeight: 'bold',
      'font-size': '2em'
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.podcastHeadingLine1)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "text-center",
    style: ({
      color: '#ffffff',
      fontWeight: 'bold',
      'font-size': '1.75em'
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.podcastHeadingLine2)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.getServicePodcast), function(pod) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('iframe', {
      attrs: {
        "src": pod.podcastUrl,
        "loading": "lazy",
        "width": "95%",
        "height": "200",
        "frameborder": "0",
        "scrolling": "no"
      }
    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(pod.artist) + " : " + _vm._s(pod.title))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(pod.description))]), _c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": pod.readMoreUrl,
        "target": "_blank"
      }
    }, [_c('h4', {
      style: ({
        color: '#000000'
      })
    }, [_vm._v("Read More")])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.corpLogos) ? _c('div', {
    staticClass: "container logoslider"
  }, [(_vm.dynamic_logosection_header) ? _c('h2', {
    staticClass: "pinkh2",
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_c('strong', [_vm._v(_vm._s(_vm.dynamic_logosection_header))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.corpLogos) ? _c('div', {
    staticClass: "slider responsive-slick-corplogos"
  }, _vm._l((_vm.corpLogos), function(logo) {
    return _c('div', {
      staticClass: "slide-player"
    }, [_c('a', {
      attrs: {
        "href": logo.linkDestination,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": logo.logoUrl,
        "alt": logo.siteNameText,
        "title": logo.siteNameText
      }
    })]), _vm._v(" "), _c('h4', {
      style: ({
        color: _vm.getCorpHeadingColor + ' !important'
      })
    }, [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor + ' !important'
      }),
      attrs: {
        "href": logo.linkDestination,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(logo.siteNameText))])])])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.getAllTestimonials) ? _c('section', {
    staticClass: "testimonialsection"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', [_vm._v("\n                                “" + _vm._s(_vm.getAllTestimonials[0].quote) + "”\n                                "), _c('div', {
    staticClass: "author"
  }, [_vm._v("--" + _vm._s(_vm.getAllTestimonials[0].author) + ", " + _vm._s(_vm.getAllTestimonials[0].location))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h3', [_vm._v("\n                                “" + _vm._s(_vm.getAllTestimonials[1].quote) + "”\n                                "), _c('div', {
    staticClass: "author"
  }, [_vm._v("--" + _vm._s(_vm.getAllTestimonials[1].author) + ", " + _vm._s(_vm.getAllTestimonials[1].location))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.dynamic_testimonial_heading) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.dynamic_testimonial_heading))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', [_vm._v("\n                                “" + _vm._s(_vm.getAllTestimonials[2].quote) + "”\n                                "), _c('div', {
    staticClass: "author"
  }, [_vm._v("--" + _vm._s(_vm.getAllTestimonials[2].author) + ", " + _vm._s(_vm.getAllTestimonials[2].location))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h4', [_vm._v("\n                                “" + _vm._s(_vm.getAllTestimonials[3].quote) + "”\n                                "), _c('div', {
    staticClass: "author"
  }, [_vm._v("--" + _vm._s(_vm.getAllTestimonials[3].author) + ", " + _vm._s(_vm.getAllTestimonials[3].location))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "fullscreenimg",
    attrs: {
      "src": require("../assets/happy.jpg"),
      "alt": "TONE EVENTS SECTION"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "eventssections text-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_6)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.event1Dest && _vm.event1Dest.indexOf('/') > -1) ? _c('span', [(_vm.event1Dest.indexOf('http') > -1) ? _c('span', [_c('a', {
    attrs: {
      "href": _vm.event1Dest,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.event1Image,
      "alt": "TONE TALK EVENT"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.event1Dest,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_7)
    }
  })])]) : _c('span', [_c('a', {
    attrs: {
      "href": _vm.event1Dest
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.event1Image,
      "alt": "TONE TALK EVENT"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.event1Dest
    }
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_7)
    }
  })])])]) : _c('span', [_c('img', {
    attrs: {
      "src": _vm.event1Image,
      "alt": "TONE TALK EVENT"
    }
  }), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_7)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.event2Dest) ? _c('span', [(_vm.event2Dest.indexOf('http') > -1) ? _c('span', [_c('a', {
    attrs: {
      "href": _vm.event2Dest,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.event2Image,
      "alt": "TONE LIVE EVENT"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.event2Dest,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_8)
    }
  })])]) : _c('span', [_c('a', {
    attrs: {
      "href": _vm.event2Dest
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.event2Image,
      "alt": "TONE LIVE EVENT"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.event2Dest
    }
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_8)
    }
  })])])]) : _c('span', [_c('img', {
    attrs: {
      "src": _vm.event2Image,
      "alt": "TONE LIVE EVENT"
    }
  }), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_8)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.event3Dest) ? _c('span', [(_vm.event3Dest.indexOf('http') > -1) ? _c('span', [_c('a', {
    attrs: {
      "href": _vm.event3Dest,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.event3Image,
      "alt": "ASK QUESTION"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.event3Dest,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_9)
    }
  })])]) : _c('span', [_c('a', {
    attrs: {
      "href": _vm.event3Dest
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.event3Image,
      "alt": "ASK QUESTION"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.event3Dest
    }
  }, [_c('h4', {
    attrs: {
      "alt": "ASK QUESTION"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_9)
    }
  })])])]) : _c('span', [_c('img', {
    attrs: {
      "src": _vm.event3Image,
      "alt": "ASK QUESTION"
    }
  }), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_9)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('section', {
    staticClass: "aboutussection"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("About Us")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-1 col-sm-10",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.mainVideoPlay) ? _c('div', {}, [_c('jwplayer', {
    attrs: {
      "id": "introVideo",
      "data": _vm.mainVideoPlay
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e(), _vm._v(" "), (_vm.getAdvisoryBoard) ? _c('div', [_c('section', {
    staticClass: "text-left advisory"
  }, [_c('h2', {
    style: ({
      fontWeight: 'bold',
      'font-size': '2em'
    })
  }, [_vm._v("ADVISORY BOARD")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.getAdvisoryBoard), function(member) {
    return _c('div', {
      staticClass: "mb-3 col-sm-12"
    }, [_c('span', {
      style: ({
        color: '#f0617d',
        fontWeight: 'bold',
        'font-size': '1.2em'
      })
    }, [_vm._v(_vm._s(member.key))]), _vm._v(" "), _c('span', {
      style: ({
        textAlign: 'left',
        fontWeight: 'bold',
        'font-size': '1.1em'
      })
    }, [_vm._v(_vm._s(member.value))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.dynamic_aboutus_video2_code && this.dynamic_aboutus_video2_code.length > 3 && (_vm.dynamic_aboutus_video2_code !== ' ' || _vm.dynamic_aboutus_video2_code !== '')) ? _c('div', {
    staticClass: "row"
  }, [(_vm.dynamic_aboutus_video2_title && (_vm.dynamic_aboutus_video2_title !== ' ' || _vm.dynamic_aboutus_video2_title !== '')) ? _c('h2', [_vm._v(_vm._s(_vm.dynamic_aboutus_video2_title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-1 col-sm-10",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.unauthPromoVideo) ? _c('div', {}, [_c('jwplayer', {
    attrs: {
      "id": "unauthpromovideo",
      "data": _vm.unauthPromoVideo
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()]) : _vm._e()])])], 1), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    attrs: {
      "effect": "zoom",
      "value": _vm.showModal,
      "width": "400"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal('0')
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('jwplayer', {
    attrs: {
      "data": _vm.currentPlayerID
    }
  }, [_vm._v("Loading the player...")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showWatchVideoModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showWatchVideoModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal('1')
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg"),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelModal('1')
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('jwplayer', {
    attrs: {
      "data": _vm.currentPlayerID,
      "id": "unAuthPlayer"
    }
  }, [_vm._v("Loading the player...")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.currentVideoDesc) + "\n                ")]), _vm._v(" "), (!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redirectSignupFromPopUp()
      }
    }
  }, [_vm._v("Start Your Free Trial")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v("Redeem Your Gift")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "applicationdownload"
  }, [_c('img', {
    staticClass: "showmobile",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/app-image-resized-rebrand.png",
      "alt": "DOWNLOAD MOBILE APP",
      "title": "Download Mobile App"
    }
  }), _vm._v(" "), _c('h2', [_c('b', [_vm._v("Get TONE on your Phone with the TONE app")])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://apps.apple.com/us/app/tone-networks-advice-on-demand/id1444962883?ls=1"
    }
  }, [_c('img', {
    staticClass: "appbtn",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mobile-app-apple.png",
      "alt": "DOWNLOAD APPLE APP",
      "title": "Download App on IOS"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://play.google.com/store/apps/details?id=com.tonenetworks.toneapp"
    }
  }, [_c('img', {
    staticClass: "appbtn",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mobile-app-android.png",
      "alt": "DOWNLOAD ANDROID APP",
      "title": "Download App on Android"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-434fb5b0", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-434fb5b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/UnAuth.vue